<template>
  <b-row>
    <b-col>
      <div style="height: 30px"></div>
      <h2 class="step_title">Fichiers supplémentaires à intégrer aux résultats (Optionnel)</h2>
      <p>Vous pouvez ajouter des fichiers supplémentaires à associer aux résultats. Par exemple un fichier de résultats en PDF.</p>
      <b-row v-for="(link, index) in Additionnal_files" v-bind:key="index" style="margin-bottom: 20px">
        <b-col>
          <b-form-input size="sm" v-model="link.title" placeholder="Titre"></b-form-input>
        </b-col>
        <b-col>
          <input type="file" @change="onFileChangeLink(index)" />
        </b-col>
      </b-row>
      <b-button size="sm" @click="addLinkToList">Ajouter un fichier</b-button>
    </b-col>
  </b-row>
</template>

<script>
import Axios from "axios";
export default {
  props: ["Additionnal_files"],
  data() {
    return {};
  },
  methods: {
    /* Au chargement d'un lien externe */
    onFileChangeLink(index) {
      var data = new FormData();
      var _this = this;
      var file = event.target.files[0];
      data.append("image", file, file.name);
      Axios.post(this.$store.getters.base_url + "/import/additionnal_files/upload.php", data).then(function (response) {
        if (response.data.length > 0) {
          _this.$emit("uploadAdditionnalFiles", {
            index: index,
            url: "https://sportips.fr/plateformeResultats/uploads/files/" + response.data,
          });
        }
      });
    },
    /* Ajout de lien externe a l'épreuve */
    addLinkToList() {
      this.Additionnal_files.push({ title: "", url: "" });
    },
  },
};
</script>

<style scoped>
</style>